module.exports = __webpack_public_path__ + "static/media/graphic-bar.c42a046d.png";